import { T } from "@/constants/testIds";
import { ASSETS } from "@/constants/links";
import VideoTile from "@/components/VideoTile";
import Reveal from "@/components/Reveal";

export default function MemeReel() {
  return (
    <section id="tv" className="relative bg-[#0e0f0b] text-paper py-20 md:py-28 border-t border-white/5" data-testid={T.reel}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="kicker text-lime mb-4">Channel surfing</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.9]">
              DIH <span className="text-outline-lime">TV</span>
            </h2>
          </div>
          <p className="max-w-sm text-base text-paper/60">
            Three channels. Zero plot. Tap the speaker if you want to hear the vibes. He won't mind.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          <Reveal>
            <VideoTile
              index={1}
              src={ASSETS.silenceVideo}
              poster="/posters/v2.jpg"
              channel="CH.01"
              title="We move in silence"
              caption="Shades on. Dollar signs in the lenses. Outside? In this economy?"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <VideoTile
              index={2}
              src={ASSETS.rainVideo}
              poster="/posters/v3.jpg"
              channel="CH.02"
              title="Rainy day, hood still on"
              caption="He checked the chart once in 2025. Never again."
            />
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-2">
            <div data-testid={`${T.reelTile}-3`} className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
              <div className="lg:col-span-7 tv aspect-video">
                <img src={ASSETS.doIt} alt="Two dogs. One says DO IT." className="w-full h-full object-cover" />
                <div className="absolute top-3 left-3 z-10">
                  <span className="sticker sticker-ink !text-[0.6rem] !py-1 !px-2.5">
                    <span className="live-dot" /> CH.03
                  </span>
                </div>
              </div>
              <div className="lg:col-span-5 lg:pl-6">
                <div className="font-display text-3xl md:text-4xl uppercase leading-[0.95]">
                  Two dogs.
                  <br />
                  One conversation.
                </div>
                <p className="mt-4 text-base text-paper/60">
                  The most persuasive financial advisor on Robinhood Chain says exactly two words. He
                  is not licensed. He is a dog in a hoodie.
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <span className="sticker">"Should I—"</span>
                  <span className="sticker sticker-ink">"Do it."</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
